export default __webpack_public_path__ + "static/media/in.2ba1ab61.svg";